export default "__VITE_ASSET__BndghLEj__"